import { ElectronicDocumentVersion } from './electronic-document-version'
import { MappableModel } from './mappable-model'

export class ElectronicDocument extends MappableModel {
  public archived_at: string
  public boss_organization_id: number
  public created_at: string
  public created_by: number
  public current_version: ElectronicDocumentVersion
  public current_version_number: number
  public id: string
  public published_at: string
}
